import { useContext } from 'react';
import StepContext from './StepContext';

const useSteps = () => {
  return useContext(StepContext);
};

export default useSteps;
